"use client"

import { useEffect, useRef } from "react"
import { motion, AnimatePresence } from "framer-motion"
import { CheckCircle } from "lucide-react"

interface NotificationProps {
  message: string
  isVisible: boolean
  onClose: () => void
}

export default function Notification({ message, isVisible, onClose }: NotificationProps) {
  const hasShown = useRef(false)

  useEffect(() => {
    if (isVisible && !hasShown.current) {
      hasShown.current = true

      const timer = setTimeout(() => {
        onClose()
        hasShown.current = false
      }, 2000)

      return () => clearTimeout(timer)
    }
  }, [isVisible, onClose])

  return (
    <AnimatePresence>
      
    </AnimatePresence>
  )
}
